/**
 * Encapsulates a data field in double quotes and escapes internal quotes
 * if the field contains the comma delimiter, a double quote, or a newline.
 * This adheres to standard CSV/TSV quoting rules.
 */
export function escapeCsvField(field: string | number | null | undefined): string {
    if (field === null || field === undefined) {
        return '';
    }
    // Convert to string for processing
    let str = String(field);

    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        str = str.replace(/"/g, '""');
        return `"${str}"`;
    }

    return str;
}
